import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ArtLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1202.2 202.1l-39.4-.8c-8.4-.2-15-7.1-14.8-15.4l.8-39c.2-8.4 7.1-15 15.4-14.8l39.4.8c8.4.2 15 7.1 14.8 15.4l-.8 39c-.1 8.4-7 15-15.4 14.8z"
      />
      <image
        width="56"
        height="56"
        x="1155"
        y="139.5"
        transform="rotate(1.15 1183 167.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1280.4 227.3l-36.4-4.9c-9-1.2-15.3-9.5-14.1-18.5l4.9-36.1c1.2-9 9.5-15.3 18.5-14.1l36.4 4.9c9 1.2 15.3 9.5 14.1 18.5l-4.9 36.1c-1.2 9-9.5 15.3-18.5 14.1z"
      />
      <image
        width="56"
        height="56"
        x="1239"
        y="162.5"
        transform="rotate(7.66 1267 190.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1370.7 239.3l-35.8-4.8c-9.2-1.2-15.6-9.7-14.4-18.9l4.8-35.4c1.2-9.2 9.7-15.6 18.9-14.4l35.8 4.8c9.2 1.2 15.6 9.7 14.4 18.9l-4.8 35.4c-1.3 9.2-9.8 15.6-18.9 14.4z"
      />
      <image
        width="56"
        height="56"
        x="1330"
        y="162.5"
        transform="rotate(7.66 1267 190.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1188.3 295.7l-40.1 2c-8.1.4-15.1-5.9-15.4-14l-1.9-39.7c-.4-8.1 5.9-15.1 14-15.4l40.1-2c8.1-.4 15.1 5.9 15.4 14l1.9 39.7c.4 8.1-5.9 15-14 15.4z"
      />
      <image
        width="56"
        height="56"
        x="1138.5"
        y="234.3"
        transform="rotate(-2.79 1166.5 262.3)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1272 309l-36.4-4.9c-9-1.2-15.3-9.5-14.1-18.5l4.8-36c1.2-9 9.5-15.3 18.5-14.1l36.4 4.9c9 1.2 15.3 9.5 14.1 18.5l-4.8 36c-1.2 9-9.5 15.3-18.5 14.1z"
      />
      <image
        data-index={4}
        width="56"
        height="56"
        x="1230.5"
        y="244.7"
        transform="rotate(7.66 1261.5 271.7)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#98EEFF"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M1368.1 319.6l-36.4-4.9c-9-1.2-15.3-9.5-14.1-18.5l4.8-36c1.2-9 9.5-15.3 18.5-14.1l36.4 4.9c9 1.2 15.3 9.5 14.1 18.5l-4.8 36c-1.2 9-9.5 15.4-18.5 14.1z"
      />
      <image
        data-index={5}
        width="56"
        height="56"
        x="1326.5"
        y="255"
        transform="rotate(7.66 1354.5 283)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g id="group-4" transform="translate(0, -73)">
      <g id="element-4">
        <g id="component-item-4">
          <g id="Art">
            <path
              fill="#FFDD83"
              d="M1150 168.3c-40.3 13.8-87 23-93 44.6s34.5 24.5 45 27.4c10.5 2.9-46.5 19.8-49.5 47.2s19.5 44.9 54 59.3c14.9 6.2 36.3 20.2 76.5 24.2 23.1 2.3 59.7-10.9 83-11 30-.2 59.8 4.4 79-2 15.9-5.4 30.5-11.7 43.6-19 13.2-7.4 24.5-24.8 34.4-34 17.2-15.9 37-17.7 43.2-38.5 13.5-44.6-139.2-115.5-233.7-108.3 0 0-60 2.4-82.5 10.1z"
            />
            <path
              fill="#B5820D"
              d="M1233.3 170.7c-10.6-2.6-36-6.5-69-.1s-90.3 30.8-87 43.1c2.7 10 53.7 19.1 62 21.7s-55.7 27.7-56.7 56c-.6 16.9.5 25.3 15.3 32 6.5 3 22.4 4.1 30.7 8 8.5 4 23.7 15.9 44 19.3 18.7 3.1 42.1-2.2 64-1.6 29.8.7 59.9 4 81.3-4.4 16.6-6.5 35.4-23.5 50.7-32 11.1-6.2 22.5-4.4 31.3-12 13.4-11.6 19.8-29.9 24-45.3 10.6-39.6-103.7-95.1-178-88.7"
            />
            <path
              fill="#3EC4F2"
              d="M1415.3 248c0 23.7-8 48.7-49.3 60.7-20.4 5.9-37.8 25.4-64.7 32-19 4.7-48.8 3.2-69.9 5.2-37.4 3.5-41.4-8-62.1-12.5-26.8-5.9-55.3-9.6-73.4-21.3-24.3-15.7-8.6-44 45.8-69.8 37.9-17.9-75.9-20.2-60.6-33.8 30.3-26.9 86.2-47.2 150.2-47.2 96.3 0 184 36.4 184 86.7z"
            />
            <path
              fill="#2998F2"
              d="M1382.8 241.7c-12.2-5-4.1 2 10.1-18.9 1.1-1.7 2-3.3 2.6-5.1-28.1-31.1-93.3-51.2-166.5-51.2-29.2 0-56.7 4.1-80.9 11-9.5 6.4-15.8 13.5-15.8 20.4 0 19.8 29.4 22.8 38.5 33.7 9.1 10.9 11.2 20.8 2 23.8-9.1 3-13.2 0-28.4 7.9s-40.6 6-40.6 22.8c0 16.9 9.1 28.8 25.3 24.8 16.2-4 27.4-9.9 37.5-5 10.1 5 20.3 17.9 38.5 21.8 18.3 4 39.5-6 56.8-10.9 17.2-5 17.2 3 47.7-4 30.4-6.9 49.7 0 65.9-21.8 16.4-21.5 19.5-44.3 7.3-49.3z"
            />
            <path
              fill="#3EC4F2"
              d="M1361.6 215.8c-17.5-6.8-22.5.5-31.5 2s-37-3-37 12 33 4 46.5 9.5 23.5 21.5 32 8 10.5-23.5-10-31.5z"
            />
            <ellipse
              cx="1198.1"
              cy="361.2"
              fill="#D7BF60"
              rx="7.1"
              ry="3.3"
              transform="rotate(-7.252 1197.594 361.272)"
            />
            <path
              fill="#E1BC75"
              d="M1201.9 359.3c.4 3.3-2.1 3.8-5.6 4.3-3.5.4-6.7.6-7.1-2.7-.4-3.3 2-8.3 5.5-8.7 3.5-.4 6.8 3.8 7.2 7.1z"
            />
            <path
              fill="#CAA175"
              d="M1198.1 353.1c.5 1 .9 2 1 2.9.4 3.3-2.1 3.8-5.6 4.3-1.6.2-3 .3-4.3.2v.4c.4 3.3 3.6 3.1 7.1 2.7 3.5-.4 6.1-1 5.6-4.3-.2-2.2-1.8-4.8-3.8-6.2z"
            />
            <ellipse
              cx="1213.6"
              cy="363.5"
              fill="#D7BF60"
              rx="4.9"
              ry="2.2"
              transform="rotate(-7.252 1213.082 363.579)"
            />
            <path
              fill="#E1BC75"
              d="M1216.2 362.2c.3 2.3-1.4 2.6-3.8 2.9-2.4.3-4.6.4-4.8-1.8-.3-2.3 1.4-5.7 3.8-6 2.3-.2 4.5 2.7 4.8 4.9z"
            />
            <path
              fill="#CAA175"
              d="M1213.6 358c.4.7.6 1.4.7 2 .3 2.3-1.4 2.6-3.8 2.9-1.1.1-2.1.2-2.9.1v.3c.3 2.3 2.4 2.1 4.8 1.8 2.4-.3 4.1-.7 3.8-2.9-.2-1.5-1.2-3.2-2.6-4.2z"
            />
            <ellipse
              cx="1344.3"
              cy="345.2"
              fill="#D7BF60"
              rx="4.9"
              ry="2.2"
              transform="rotate(-7.252 1343.703 345.273)"
            />
            <path
              fill="#E1BC75"
              d="M1346.9 343.9c.3 2.3-1.4 2.6-3.8 2.9s-4.6.4-4.8-1.8 1.4-5.7 3.8-6c2.3-.3 4.5 2.7 4.8 4.9z"
            />
            <path
              fill="#CAA175"
              d="M1344.2 339.7c.4.7.6 1.4.7 2 .3 2.3-1.4 2.6-3.8 2.9-1.1.1-2.1.2-2.9.1v.3c.3 2.3 2.4 2.1 4.8 1.8 2.4-.3 4.1-.7 3.8-2.9-.1-1.5-1.2-3.3-2.6-4.2z"
            />
            <ellipse
              cx="1393.8"
              cy="319.7"
              fill="#D7BF60"
              rx="4.9"
              ry="2.2"
              transform="rotate(-7.252 1393.189 319.79)"
            />
            <path
              fill="#E1BC75"
              d="M1396.4 318.4c.3 2.3-1.4 2.6-3.8 2.9-2.4.3-4.6.4-4.8-1.8s1.4-5.7 3.8-6c2.3-.3 4.5 2.7 4.8 4.9z"
            />
            <path
              fill="#CAA175"
              d="M1393.7 314.2c.4.7.6 1.4.7 2 .3 2.3-1.4 2.6-3.8 2.9-1.1.1-2.1.2-2.9.1v.3c.3 2.3 2.4 2.1 4.8 1.8s4.1-.7 3.8-2.9c-.1-1.5-1.2-3.3-2.6-4.2z"
            />
            <ellipse
              cx="1132.7"
              cy="349.1"
              fill="#D7BF60"
              rx="2.2"
              ry="4.9"
              transform="rotate(-81.118 1132.77 349.118)"
            />
            <path
              fill="#E1BC75"
              d="M1135.6 348.6c-.4 2.2-2.1 2.1-4.5 1.7-2.4-.4-4.5-.9-4.1-3.1.4-2.2 2.9-5.1 5.3-4.7s3.7 3.9 3.3 6.1z"
            />
            <path
              fill="#CAA175"
              d="M1134.2 343.8c.2.7.2 1.5.1 2.1-.4 2.2-2.1 2.1-4.5 1.7-1.1-.2-2.1-.4-2.8-.7 0 .1 0 .2-.1.3-.4 2.2 1.8 2.7 4.1 3.1 2.4.4 4.2.5 4.5-1.7.3-1.5-.2-3.5-1.3-4.8z"
            />
            <ellipse
              cx="1105.1"
              cy="336.5"
              fill="#D7BF60"
              rx="2.2"
              ry="4.9"
              transform="rotate(-81.118 1105.102 336.452)"
            />
            <path
              fill="#E1BC75"
              d="M1107.9 336c-.4 2.2-2.1 2.1-4.5 1.7s-4.5-.9-4.1-3.1c.4-2.2 2.9-5.1 5.3-4.7 2.3.4 3.7 3.8 3.3 6.1z"
            />
            <path
              fill="#CAA175"
              d="M1106.6 331.2c.2.7.2 1.5.1 2.1-.4 2.2-2.1 2.1-4.5 1.7-1.1-.2-2.1-.4-2.8-.7 0 .1 0 .2-.1.3-.4 2.2 1.8 2.7 4.1 3.1s4.2.5 4.5-1.7c.3-1.5-.3-3.5-1.3-4.8z"
            />
            <ellipse
              cx="1124.2"
              cy="238.1"
              fill="#D7BF60"
              rx="2.2"
              ry="4.9"
              transform="rotate(-81.118 1124.254 238.062)"
            />
            <path
              fill="#E1BC75"
              d="M1127.1 237.6c-.4 2.2-2.1 2.1-4.5 1.7-2.4-.4-4.5-.9-4.1-3.1.4-2.2 2.9-5.1 5.3-4.7 2.3.4 3.6 3.8 3.3 6.1z"
            />
            <path
              fill="#CAA175"
              d="M1125.7 232.8c.2.7.2 1.5.1 2.1-.4 2.2-2.1 2.1-4.5 1.7-1.1-.2-2.1-.4-2.8-.7 0 .1 0 .2-.1.3-.4 2.2 1.8 2.7 4.1 3.1 2.4.4 4.2.5 4.5-1.7.3-1.5-.2-3.5-1.3-4.8z"
            />
            <ellipse
              cx="1413.5"
              cy="213.4"
              fill="#D7BF60"
              rx="2.2"
              ry="4.9"
              transform="rotate(-81.118 1413.596 213.39)"
            />
            <path
              fill="#E1BC75"
              d="M1416.4 212.9c-.4 2.2-2.1 2.1-4.5 1.7-2.4-.4-4.5-.9-4.1-3.1.4-2.2 2.9-5.1 5.3-4.7 2.3.4 3.7 3.9 3.3 6.1z"
            />
            <path
              fill="#CAA175"
              d="M1415.1 208.1c.2.7.2 1.5.1 2.1-.4 2.2-2.1 2.1-4.5 1.7-1.1-.2-2.1-.4-2.8-.7 0 .1 0 .2-.1.3-.4 2.2 1.8 2.7 4.1 3.1s4.2.5 4.5-1.7c.3-1.5-.3-3.5-1.3-4.8z"
            />
            <path
              fill="#24660A"
              d="M1228.5 251.1c-13.3 8.3-2 22.9 26.7 16.2s46-33.7 18.7-41.4c-27.3-7.7-66.7 3.6-64.7 13.4 2 9.7 16.7 9.2 19.3 11.8zM1161.1 201.5c-13.3 8.3-2 22.9 26.7 16.2 28.7-6.7 46-33.7 18.7-41.4-27.3-7.7-66.7 3.6-64.7 13.4 2 9.7 16.7 9.2 19.3 11.8zM1327.9 261c-14.3 6.5-4.9 22.4 24.4 19.5 29.3-2.9 50-27.5 23.9-38.7-26.1-11.2-66.6-5-65.9 4.9.7 10 15.3 11.4 17.6 14.3z"
            />
            <path
              fill="#FFDC05"
              d="M1316 323.2c2.1-4-6.3.8-12.3 4.2-6 3.3-18.3 2.5-16 5.2 2.3 2.6 25.4-4.1 28.3-9.4z"
              opacity="0.45"
            />
            <path
              fill="#FFDC05"
              d="M1310.9 329.5c.7-1.6-8.6 3.4-11.3 3.9-2.6.6-5.8-.1-4.8 2.1s14.4-2.2 16.1-6z"
              opacity="0.45"
            />
            <path
              fill="#E33682"
              d="M1222.3 304.8c2.1-4-6.3.8-12.3 4.2-6 3.3-18.3 2.5-16 5.2 2.3 2.6 25.5-4 28.3-9.4z"
              opacity="0.43"
            />
            <path
              fill="#E33682"
              d="M1217.2 311.1c.7-1.6-8.6 3.4-11.3 3.9-2.6.6-5.8-.1-4.8 2.1 1.1 2.3 14.5-2.1 16.1-6z"
              opacity="0.43"
            />
            <path
              fill="#98EEFF"
              d="M1252.6 274.3c3.2-3.2-6.3-1-13 .5s-18.3-2.8-16.8.4c1.5 3.2 25.6 3.4 29.8-.9z"
              opacity="0.34"
            />
            <path
              fill="#98EEFF"
              d="M1245.9 278.9c1.1-1.3-9.2.8-11.9.5-2.7-.2-5.5-1.8-5.2.7.4 2.5 14.4 2 17.1-1.2z"
              opacity="0.34"
            />
            <path
              fill="#A3F840"
              d="M1376.7 279.8c2.5-3.8-6.4.3-12.6 3.1-6.3 2.8-18.5.9-16.4 3.8 2.1 2.8 25.8-1.9 29-6.9z"
              opacity="0.58"
            />
            <path
              fill="#A3F840"
              d="M1371.1 285.6c.8-1.5-8.9 2.6-11.5 2.9-2.7.3-5.8-.6-5 1.7s14.5-.9 16.5-4.6z"
              opacity="0.58"
            />
            <path
              fill="#41760A"
              d="M1228.6 249.8c-13.3 8.3-2 22.9 26.7 16.2s46-33.7 18.7-41.4c-27.3-7.7-66.7 3.6-64.7 13.4s16.7 9.2 19.3 11.8z"
            />
            <path
              fill="#24660A"
              d="M1158.1 293.8c-13.3 8.3-2 22.9 26.7 16.2 28.7-6.7 46-33.7 18.7-41.4-27.3-7.7-66.7 3.6-64.7 13.4s16.7 9.2 19.3 11.8z"
            />
            <path
              fill="#41760A"
              d="M1158.6 292.5c-13.3 8.3-2 22.9 26.7 16.2 28.7-6.7 46-33.7 18.7-41.4-27.3-7.7-66.7 3.6-64.7 13.4 2 9.7 16.7 9.2 19.3 11.8zM1328.2 259.9c-14.3 6.5-4.9 22.4 24.4 19.5 29.3-2.9 50-27.5 23.9-38.7-26.1-11.2-66.6-5-65.9 4.9.7 10 15.3 11.4 17.6 14.3z"
            />
            <path
              fill="#24660A"
              d="M1262.6 313.3c-13.3 8.3-2 22.9 26.7 16.2s46-33.7 18.7-41.4-66.7 3.6-64.7 13.4 16.7 9.2 19.3 11.8z"
            />
            <path
              fill="#41760A"
              d="M1262.6 311.8c-13.3 8.3-2 22.9 26.7 16.2s46-33.7 18.7-41.4-66.7 3.6-64.7 13.4 16.7 9.2 19.3 11.8zM1161.3 199.8c-13.3 8.3-2 22.9 26.7 16.2s46-33.7 18.7-41.4-66.7 3.6-64.7 13.4 16.6 9.2 19.3 11.8z"
            />
            <path
              fill="#FFF"
              d="M1242.2 323.3c.6-2.7-.9-4.2-10 .8s-29.3-4.3-30.7-.3c-1.3 4 5.5 7.1 13.3 7.3s14.9-.7 15.5 1.3c.5 2-15.6-.4-15.5 2.2.1 2.7 9.6 5.3 19.7 3s14.4-9.1 13.7-11c-.7-1.9-8.3 4.4-10 3.1s3.4-3.8 4-6.4zM1131.8 194.8c-4-1.5-5.7 9.8-3.4 15.8 2.3 5.9 10.3 8 12.9 4.9 2.6-3.1-2.6-.5-5.9-7.2-3.4-6.7 2.1 3 4.4 2.3 2.3-.6-1.5-2.7-3-6.5-1.4-3.7 2.6-10.8.8-12s-3.5 9.4-4.5 8.7c-1-.8.8-5.2-1.3-6z"
            />
            <g>
              <path
                fill="#68C902"
                d="M1311.7 365.5c-7.8-1.5-15.6-2.7-23.4-3-7.8-.4-15.4.1-22.8 1.7-7.5 1.6-15.1 4.3-23.2 6.5-4.1 1-8.1 2.1-12.3 2.8-4.1.9-8.3 1.4-12.4 2-33.3 4.1-67.6-.9-98.2-14.6l-3.4-1.7c-1.1-.6-2.2-1.1-3.3-1.7-2.2-1.2-4.4-2.5-6.6-3.7 2.2 1.1 4.4 2.1 6.6 3.1-.3-.3-.7-.6-1.1-.7-.1-.1-.3-1 .2-1.3.5-.2 1.1-.3 1-.5.4.2.7.7.6.8.3-.2.7-.3 1.2-.2.5.1 1.2 0 .9-.4.6.2 1.5 1.6.5 2.4.4-.1.9.1 1.2.1 1.2-.2 2.2-.3 2-.7.9.6 1.6 1.5 1.1 1.9.9-.4 2.1-.5 3.3-.3 1.2.2 3.2.1 2.7-.8 1 .4 2.2 2.1 1.5 3.7.4.1.8.1 1.2.3.9.3 2.5.5 2.5 0 .5.3.8 1 .2 1.7.8.1 1.6.2 2.3.2 3 .1 3.1-.2 3.7-.9.1-.2.8 0 1.1.2.3.3.6.7.7 1 .8.4 1.7 1 1.4 1.4.5-.6 1.3-.9 2.3-.9 1-.1 2.4-.4 1.7-1.1 1.2.3 3.5 2.7 1.7 4.7.8-.3 1.8-.2 2.3-.2v.1c2.3-.9 4.2-1.5 3.7-2.2 2 .8 3.8 2.4 3 3.3 1.5-1.2 3.9-2 6.3-2.2 1.2-.1 2.8-.3 3.9-.8s1.7-1.2 1-1.9c2.1.3 5.2 3.1 4.7 6.5.8-.1 1.7-.1 2.5-.1 1.9 0 5.2-.4 4.9-1.5 1.2.3 2 1.6 1.3 3.2 1.5-.2 3.1-.4 4.6-.8 5.8-1.5 5.9-2.1 6.5-3.9.1-.4 1.6-.5 2.2-.3 2.8 1.4 3.4 3.1 1.3 5.2-1 1-2.3 1.8-3.7 2.4H1193c1-.3 2.1-.5 3.1-.7 3.7-1.1 3.7-1.5 4-2.7.1-.3 1-.4 1.4-.2 1.8.8 2.3 1.9 1 3.2l-.3.3c2-.1 4-.2 6.1-.3 0-.1.1-.2.1-.2.5-.6 1-1.1.8-1.2.6 0 1.3.2 1.2.5.1-.4.6-.8 1.1-1.1.6-.3 1.3-.8.7-1.1.8-.1 2.8.8 2.2 2.4.4-.4 1.1-.5 1.4-.6v.1c1.2-1 2.2-1.9 1.8-2.2 1.4 0 2.9.5 2.6 1.3.7-1.1 1.9-2.1 3.4-2.7 1.5-.6 3.6-2.1 2.4-2.7 1.4-.3 3.9.8 4.3 3l1.5-.6c.6-.2 1.4-.5 2-.8.6-.4 1-.8.7-1 .8-.1 1.6.6 1.5 1.7.9-.5 1.9-.9 2.7-1.4 3.4-2 3.3-2.4 3.3-3.6 0-.3.9-.6 1.3-.6 2 .4 2.7 1.3 1.8 3-.4.7-1 1.4-1.8 2.1.4-.1.7-.2 1.1-.3.6-.3 1.2-.6 1.7-1 2.1-1.3 2-1.6 2-2.4 0-.2.6-.4.8-.4 1.3.2 1.7.8 1.1 1.8-.1.1-.1.2-.2.3 7.4-2.2 14.1-4.1 20.7-4.8 6.6-.8 13-.7 19.2-.2 12.4 1.1 24.1 4 36.2 7.1-4.8-1.3-9.5-2.1-14.2-2.8zm-174.5.3v-.4c-.4.1-.9.1-1.3.1l.8.2c.1.1.3.1.5.1z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1158.4 370.6c-18.1-5.1-36-10.9-53.6-17.6-1.2-.7-2.5-1.3-3.8-2 .7.2 1.3.3 2 .5-.1-.2-.2-.2-.3-.2 0-.1.1-.8.3-1.2.3-.4.5-.6.5-.8.1.1.2.3.1.5.2-.3.3-.5.5-.6.2-.1.5-.4.4-.7.2 0 .3.9-.3 2 .2-.2.3-.2.4-.2.5-.6.9-.9.9-1.2.2.3.3.9 0 1.3.4-.7.9-1.1 1.3-1.2.4-.2 1.2-.7 1.2-1.4.3.1.4 1.4-.2 2.9.1-.1.3-.1.4-.1.3 0 .8-.2 1-.7.1.1 0 .8-.3 1.5.3-.1.5-.1.8-.3 1.1-.5 1.2-.8 1.6-1.6.1-.2.3-.2.3 0v.7c.2.2.3.6.2 1 .3-.6.7-1 1-1.2.4-.2.9-.8.9-1.3.4 0 .6 1.9-.6 4 .4-.4.7-.5.9-.5v.1c1-1.2 1.8-2 1.8-2.5.5.5.7 1.8.1 2.7.9-1.4 1.8-2.2 2.7-2.6.9-.4 2.4-1.5 2.4-2.9.6.2.8 2.8-.4 6 .3-.1.6-.2.8-.2.6 0 1.7-.4 1.9-1.4.3.3.1 1.6-.6 3.1.5-.2 1.1-.3 1.6-.6 2.1-1.1 2.4-1.7 3.1-3.4.2-.4.6-.4.7 0 .3 1.6-.1 3.3-1.3 5-.6.8-1.2 1.5-1.8 2l.5.2c.4-.2.7-.2 1.1-.4 1.3-.7 1.5-1.1 1.9-2.1.1-.2.4-.2.4 0 .2 1 0 2.1-.8 3.2-.1.1-.1.2-.2.2.5.2 1.1.3 1.6.5 0-.1.1-.1.1-.2.3-.5.6-.9.6-1 .1.1.2.4.1.7.2-.4.4-.7.6-.8.2-.1.6-.5.5-.9.2 0 .4 1.2-.3 2.6.2-.3.4-.3.5-.3v.1c.6-.8 1.1-1.3 1.1-1.7.3.3.5 1.1.1 1.7.5-.9 1.1-1.5 1.7-1.7.6-.2 1.5-1 1.5-1.9.4.1.6 1.8-.1 3.9.2-.1.4-.1.5-.1.4 0 1.1-.3 1.2-.9.2.2.1 1-.3 2 .3-.1.7-.2 1-.4 1.4-.7 1.5-1.1 1.9-2.2.1-.3.4-.2.4 0 .2 1 0 2.1-.8 3.3-.3.5-.7.9-1.1 1.3l.3.1c.2-.1.4-.2.7-.3.9-.5.9-.7 1.2-1.4.1-.2.2-.2.3 0 .1.6 0 1.3-.5 2.1 0 .1-.1.1-.1.2 8.3 2.9 14.7 5.5 21.4 8.3-.8-.6-2.2-.8-3.6-1zm-48.2-17.4c0-.1.1-.2.1-.3-.2.2-.3.3-.5.4l.2.1.2-.2z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1151 362.5c-17.9-3.3-35.7-7.2-53.3-11.7-1.3-.5-2.5-1-3.8-1.5.7.1 1.3.2 2 .2-.1-.1-.2-.2-.3-.2 0-.1 0-.8.2-1.2.2-.4.4-.7.4-.8.1.1.2.3.1.5.1-.3.3-.5.4-.7.2-.1.4-.4.4-.7.2 0 .4.9-.1 2 .2-.2.3-.3.4-.3.4-.6.8-1 .8-1.3.2.2.4.8.2 1.3.4-.7.8-1.2 1.2-1.4.4-.2 1.1-.9 1-1.6.3.1.5 1.3.1 2.9.1-.1.3-.1.4-.1.3 0 .8-.3.9-.8.1.1.1.8-.2 1.5.2-.1.5-.2.7-.4 1-.6 1.1-.9 1.3-1.8.1-.2.3-.2.3-.1.1.2.1.5.1.7.2.1.4.6.3 1 .2-.6.6-1.1.9-1.3.3-.2.8-.9.7-1.4.4 0 .7 1.8-.2 4.1.3-.5.6-.6.8-.6v.1c.9-1.3 1.6-2.2 1.5-2.7.5.5.8 1.7.4 2.7.7-1.4 1.6-2.4 2.3-2.9.8-.5 2.2-1.8 2-3.2.6.1 1 2.7.2 6 .3-.2.5-.2.8-.3.6-.1 1.6-.5 1.7-1.6.3.2.3 1.5-.3 3.1.5-.3 1-.4 1.5-.8 2-1.3 2.1-2 2.7-3.7.1-.4.6-.4.7-.1.5 1.5.2 3.3-.8 5.1-.5.9-1 1.6-1.5 2.1l.5.1c.3-.2.7-.3 1-.5 1.2-.8 1.3-1.2 1.7-2.3.1-.3.4-.3.4-.1.3 1 .2 2.1-.5 3.2 0 .1-.1.2-.1.2.5.1 1.1.2 1.6.3 0-.1 0-.1.1-.2.3-.5.5-.9.5-1.1.1.1.3.4.2.7.1-.4.3-.7.5-.9.2-.2.5-.6.4-.9.2 0 .5 1.2 0 2.6.2-.3.4-.4.5-.4v.1c.6-.8 1-1.4 1-1.8.3.3.5 1.1.3 1.7.4-.9 1-1.6 1.5-1.9.5-.3 1.4-1.2 1.3-2.1.4.1.7 1.7.2 3.9.2-.1.3-.2.5-.2.4 0 1-.4 1.1-1 .2.2.2 1-.1 2 .3-.2.6-.3.9-.5 1.3-.9 1.4-1.3 1.7-2.4.1-.3.4-.3.4-.1.3 1 .2 2.1-.4 3.3-.3.5-.6 1-.9 1.4l.3.1.6-.3c.8-.6.9-.8 1.1-1.5 0-.2.2-.2.3-.1.2.6.1 1.3-.3 2.1 0 .1-.1.1-.1.2 8.3 2 14.6 4 21.4 6.1-1.8.4-3.1.3-4.5.2zm-48-12.2v-.3c-.1.2-.3.3-.4.5h.2c0-.1.1-.1.2-.2z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1307.7 367.9c-5.9-1.8-12.1-2.8-18.4-3.3-6.3-.5-12.6-.4-19 .1-12.7 1.1-25.5 3.8-38.3 6.8-1.9.3-3.9.6-5.9.9l2.7-.9c-.2-.1-.4-.1-.5 0-.1-.1-.5-.7-.4-1.2 0-.5.2-.8 0-.9.2 0 .4.1.5.4 0-.3.1-.6.2-.8.1-.2.3-.6.1-.8.2-.1 1 .6 1 1.8.1-.3.3-.4.3-.5.2-.8.4-1.3.3-1.6.5.1 1 .5 1 1 .1-.8.4-1.5.8-1.9.4-.4.9-1.3.5-1.9.4-.1 1.4.9 1.8 2.5.1-.1.3-.2.4-.3.4-.2.9-.7.7-1.1.3 0 .6.6.6 1.4.3-.2.5-.5.8-.7.9-1.1.9-1.4.8-2.3 0-.2.3-.3.4-.2.2.2.4.4.5.6.4 0 .9.3.9.7 0-.7.1-1.3.4-1.6.3-.4.6-1.2.2-1.6.5-.2 2 1.2 2 3.6.2-.6.5-.8.7-.9v.1c.5-1.6 1-2.7.6-3.2.9.1 2 1.1 2 2.1.2-1.6.8-2.9 1.7-3.7.9-.8 2-2.7 1.1-3.8.9-.2 2.8 1.9 3.4 5.3.3-.3.6-.5.9-.6.7-.3 1.9-1.2 1.6-2.2.5.1 1.1 1.3 1.2 3 .5-.5 1.1-.9 1.6-1.4 2.1-2.1 2-2.7 2-4.5 0-.4.6-.6.9-.4 1.4 1.2 1.8 2.9 1.3 5-.3 1-.7 1.9-1.1 2.6l.7-.1c.4-.3.8-.6 1.1-.9 1.3-1.3 1.3-1.7 1.3-2.8 0-.3.4-.4.5-.2.8.8 1.1 1.9.7 3.2 0 .1-.1.2-.1.3l2.4-.3v-.2c.1-.6.3-1 .2-1.2.2 0 .5.3.5.5 0-.4.2-.8.4-1 .2-.2.5-.7.2-1 .3-.1 1.2.9 1 2.5.1-.3.4-.5.5-.5v.1c.4-1 .8-1.7.6-2 .6.2 1.2.9 1.1 1.5.2-1 .8-1.8 1.4-2.3.6-.4 1.5-1.5 1-2.4.6 0 1.6 1.4 1.7 3.7.2-.2.4-.3.6-.3.5-.1 1.3-.6 1.2-1.3.3.1.6.9.5 2 .4-.3.8-.5 1.2-.7 1.5-1.1 1.5-1.6 1.7-2.7 0-.3.4-.4.6-.2.8.9.9 2 .4 3.3-.2.6-.6 1.1-.9 1.5h.5c.3-.2.5-.3.8-.5.9-.7 1-1 1.1-1.7 0-.2.3-.2.4-.1.5.6.5 1.3.2 2.1 0 .1-.1.2-.1.2 6.1.3 11.4 1.1 16.3 2.3 4.9 1.2 9.3 2.9 13.6 5-.9-.2-1.8-.5-2.7-.7-1.1-.3-2-.5-2.9-.7zm-69 .3c0-.1-.1-.2-.1-.3l-.3.6.3-.1c0-.1 0-.2.1-.2z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1346.7 364.7l-17.1.7-8.6.4c-1.3.1-2.5.1-3.5.3-.5.1-.9.2-1.2.3-.3.1-.6.2-.7.3-.3 0-.5-.1-.7 0v-.4c-.1-.1-.1-.1-.1 0-.1-.1-.6-.5-.9-.8-.3-.3-.5-.6-.6-.6.1 0 .2.1.4.3-.2-.2-.4-.5-.4-.6-.1-.1-.3-.5-.5-.6 0-.1.7.4 1.4 1.4-.1-.2-.2-.3-.2-.4-.4-.6-.6-1.1-.8-1.3.2 0 .6.4.9.9-.4-.7-.6-1.2-.6-1.6 0-.4-.1-1.2-.5-1.7.2-.1 1 .8 1.6 2.4 0-.1 0-.2.1-.3.1-.1.2-.5 0-1 .1 0 .4.6.6 1.4 0-.2.1-.4.1-.6.1-.9.1-1.2-.1-2.1 0-.2.1-.3.2-.2l.3.6c.2 0 .4.4.5.8-.1-.7-.1-1.2 0-1.5.1-.3.2-1.1-.1-1.6.2-.1 1 1.4 1.2 3.8 0-.5.2-.7.2-.8v.1c.1-1.5.3-2.5.1-3 .4.3.9 1.4.9 2.4.1-1.6.4-2.8.8-3.4.4-.7 1-2.3.6-3.6.5 0 1.1 2.3 1.3 5.7.1-.2.3-.4.4-.5.3-.2.9-.9.8-2 .2.2.4 1.4.4 3.1.3-.4.5-.7.7-1.1.9-1.8.9-2.4.9-4.2 0-.4.3-.6.4-.3.6 1.4.7 3.1.5 5.1-.1 1-.3 1.8-.5 2.4h.3c.2-.3.4-.5.5-.8.6-1.1.6-1.5.6-2.7 0-.3.2-.3.2-.2.4.9.5 2 .3 3.2v.3c.3 0 .7 0 1-.1v-.2c.1-.6.1-1 .1-1.2.1 0 .2.3.2.6 0-.4.1-.8.2-1 .1-.2.2-.7.1-1 .1-.1.5 1 .4 2.6.1-.3.2-.5.2-.5v.1c.2-1 .3-1.6.3-1.9.3.2.5.9.5 1.6.1-1 .3-1.8.6-2.2.3-.4.6-1.5.4-2.3.3 0 .7 1.5.8 3.7l.3-.3c.2-.1.6-.6.5-1.3.1.1.3.9.3 2 .2-.3.3-.4.5-.7.6-1.2.6-1.6.6-2.7 0-.3.2-.4.2-.2.4.9.5 2 .3 3.3-.1.6-.2 1.1-.3 1.5h.2c.1-.2.2-.3.3-.5.4-.7.4-1 .4-1.7 0-.2.1-.2.2-.1.2.6.3 1.3.2 2.1v.2c5.4.1 9.6.6 14 1.4-.9.4-1.8.6-2.6.8zm-30.3-.1c0-.1-.1-.2-.1-.3v.6h.1v-.3z"
              />
            </g>
            <g>
              <g fill="#FFF">
                <path d="M1153.5 394.4c-.5-.1-.7-.3-.7-.7v-.9c0-.3 0-.5.1-.7 0-.2.1-.3.2-.4.1-.1.3-.1.4-.1.2 0 .4 0 .8.1.4-1.2.8-2.3 1.2-3.5.4-1.1.9-2.2 1.3-3.2.2-.4.4-.6.8-.7.3-.1.6-.1 1-.1.3 0 .6-.1.9-.1h.8c.4 0 .7.2.9.6.4.7.8 1.7 1.3 2.9s1 2.5 1.5 3.9H1164.7c.3 0 .6.2.6.5.1.3.1.7.1 1.1v.6c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2.1.3.2.5.2.8.1.2.1.5.2.7 0 .1.1.2.1.3v.1c0 .3-.1.5-.4.6-.4.1-.7.2-1.1.3-.4.1-.8.1-1.2.1-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5l-.5-1.9c-.7 0-1.4.1-2.1.1h-1.3c-.4 0-.9 0-1.3-.1-.1.3-.2.7-.2 1-.1.3-.1.6-.2 1s-.3.6-.7.6c-.3 0-.7 0-1.1-.1-.4-.1-.8-.2-1.1-.2-.3-.1-.4-.3-.4-.6v-.1-.2c0-.2.1-.4.2-.7.3-.4.4-.7.4-1zm4.2-2.6h3c-.2-.7-.5-1.4-.7-2.2-.3-.7-.5-1.4-.8-2-.3.7-.5 1.5-.7 2.2-.4.6-.6 1.3-.8 2zM1166.6 389.2c0-.3 0-.5.1-.7 0-.2.2-.3.4-.4.1 0 .3-.1.5-.1s.4 0 .6-.1h1.1c.2 0 .3 0 .4.1.1.1.1.2.1.3v.6c.3-.3.7-.5 1.1-.7.4-.2.9-.3 1.3-.3.3 0 .6.1.8.4.2.3.3.5.4.8.1.3.1.6.1.9v.8c0 .2-.1.5-.2.7-.1.2-.4.4-.7.6l-.6.3c-.2.1-.4.1-.6.1-.2 0-.4-.1-.5-.3-.1-.2-.2-.4-.2-.6v-.5c0-.2 0-.4-.1-.6-.2.1-.3.2-.5.2-.1.1-.3.2-.5.4v1.8c0 .6.1 1.1.1 1.5 0 .4.1.8.1 1.1v.6c0 .2-.1.4-.2.5-.1.1-.4.2-.8.2h-1.2c-.4 0-.6-.1-.7-.2-.1-.1-.2-.4-.2-.6-.1-.9-.2-1.8-.2-2.8-.1-.9-.1-1.9-.1-2.8v-.6c0-.2.2-.4.2-.6zM1173.8 389.7v-.5c0-.1.1-.2.2-.3.1-.1.2-.1.3-.2.1 0 .3-.1.6-.1v-.5-.7-.7c0-.2 0-.4.1-.6.1-.2.2-.3.3-.4.2-.1.4-.2.7-.2.3 0 .7-.1 1.3-.1.3 0 .5.1.6.2.1.1.2.3.2.6v2.3c.2 0 .4 0 .6.1.2 0 .4 0 .6.1.2 0 .4.1.5.2.1.1.1.3.1.5v.5c0 .2 0 .4-.1.5 0 .2-.1.4-.2.5-.1.1-.3.1-.6.2-.2 0-.3 0-.5.1h-.4c0 .4 0 .8.1 1.4 0 .5 0 1 .1 1.5 0 .5.1.9.1 1.3v.8c0 .2 0 .4-.1.5-.1.1-.3.2-.5.2-.5.1-.9.1-1.4.1-.2 0-.4-.1-.5-.2s-.2-.3-.2-.6c-.1-.8-.2-1.7-.3-2.5-.1-.8-.1-1.7-.2-2.6l-.5-.1c-.3 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5v-.4c-.2.1-.2-.1-.2-.2z" />
              </g>
            </g>
            <g>
              <path
                fill="#B8800C"
                d="M1341 126.7s5.6 3.5 7.8 5.9 14.3 1.4 14.3 1.4l3.2 3.9s-15.5.7-19.8-2.4c-4.3-3.2-5.5-8.8-5.5-8.8zM1393.6 79.9s-.5 36.4 13.2 49.2c13.6 12.9 23.7 11.5 23.7 11.5l-.2-10.5s-14.1-4.6-22.8-18.7-9.8-28-9.8-28l-4.1-3.5z"
              />
              <path
                fill="#B8800C"
                d="M1286.3 114.3c14.8 5.5 29.4 37.5 72.4 47.6s57.8.9 70 8.4c12.2 7.5 2.7-21.7 2.7-21.7s-10.9-1.6-30.2 1c-19.2 2.6-39.9 4.3-53.4-2.6s-55.3-34.4-61.5-32.7z"
              />
              <path
                fill="#B8800C"
                d="M1338 110.9c6.2 2.4 25 22.4 27.6 30.5 2.5 8.1 9.7 14.5 9.7 14.5l13.5-.2s-10-12.2-17.6-19c-7.6-6.8-12.7-15.7-17.4-19.5s-15.8-6.3-15.8-6.3zM1329.8 144.7c-3.4-1.3-11.1 5.3-12.6 10.2-1.5 5-4.8 9.4-7.7 11.2-2.9 1.7-18.7 3.3-18.7 3.3s20.6 3.3 25.1-2 9.8-15.2 9.8-15.2l9-1.6-4.9-5.9z"
              />
              <path
                fill="#815418"
                d="M1347 118.7c4 2.3 8.4 8.4 8.4 8.4l9.4 3.3s-11.3-15.5-16-17.5c-1.3 2.4-1.8 5.8-1.8 5.8zM1314 138.9c8.6 7.9 10.4 7.3 10.4 7.3s5.4-4.7 19.8-1c-15.9-12.5-29.1-18.1-29.1-18.1l-1.1 11.8zM1396 112s2.2 9.5 8.3 14.6c4.1-3.2 14.2-3.2 14.2-3.2s-16-14.1-16.3-16.1c-2.8 1.5-6.2 4.7-6.2 4.7z"
              />
              <path
                fill="#B8800C"
                d="M1492.5 204s17.6-15.3 20.7-30.1c3.2-14.8 3.7-28.1 3.7-28.1l5.9 1.3s-.1 19.8 0 40.8c-4.9 16-13.3 31.3-27.8 34.7-5.8-12.9-2.5-18.6-2.5-18.6z"
              />
              <path
                fill="#815418"
                d="M1522.8 147.1c-2.1 18.2-9 55.5-31.2 63.2.2 3 1 7 3.4 12.3 14.2-3.3 22.8-18.9 27.8-34.5.2-17.2 0-41 0-41z"
              />
              <path
                fill="#B8800C"
                d="M1496.3 354.1c4.7-1.2 17.2-.7 26.5.8 0-2.3-.8-14.9 0-20.3-1.9-2.3-3.8-4.7-5.1-6.5-3.1-4.2-10.2-15.1-12.8-19.4-8.8-53.1-10.5-138.1-4.7-201.2-12.2-36.7-73.8 1.9-73.8 1.9s-.1 136.1-10.7 207.5c-5 11.9-13.6 26.3-22.7 29.1-11.3 3.5-23.9 7-29.7 12.2s-21.2 17.8-21.2 17.8 22.8-9.9 34.7-15.2c11.9-5.3 21-3.2 21-3.2l8.3 3.6s-11 3.9-13.6 14.1c-5.5 12.7-8.5 15.2-8.5 15.2s12.3-5.3 17.2-13c4.9-7.6 9.3-10.2 13.8-10 4.5.2 10.9-6.2 15.3-7.4s6.7-.9 6.7-.9 10.6 10.3 15.7 14.1c5.2 3.8 18.7 3.4 25.9 3.9 7.2.5 36.8 12.3 36.8 12.3s-15.7-12.7-25-17.2-26.1-6.1-26.1-6.1l10.8-8c.2 0 14.1-2.3 21.2-4.1z"
              />
              <path
                fill="#815418"
                d="M1522.8 334.6c-1.9-2.3-3.8-4.7-5.1-6.5-3.1-4.2-10.2-15.1-12.8-19.4-8.8-53.1-10.5-138.1-4.7-201.2-5-15.2-18.6-17.5-32.7-14.9 3.5 8.1 5.9 17.8 5.1 27.6-1.5 19.3-7.4 56.7-7.6 74.5-.3 17.8 5 36.7 8.2 44.7s6 9.2 5.4 21.6c-.6 12.4-10.3 30.8-5.6 41.5 4.7 10.7 2.6 20.4 4.5 28.5 1.8 8.1-24.1 10.7-26.6 15.4-2.4 4.7.4 6.4 11.2 13.9 1.6 1.1 3.8 2.2 6.2 3.1l8-4s13-3.6 20.1-5.4c4.7-1.2 17.2-.7 26.5.8-.1-1.3-.1-14.7-.1-20.2z"
              />
              <path
                fill="#41760A"
                d="M1413.6 97.7c1 7.4 2.3 15.2 7.1 20.8 7.9 9.2 21.8 8.9 33.8 7.8 2.2 12 12.6 21.2 24 25.2 11.4 4.1 23.8 4 35.8 3.9 2.8 0 8.5-1.8 8.5-1.8V.2s-77.1-.1-101.7-.4c-1.2 2.1-2.1 4.3-2.8 6.6-14.9 2.6-28 13.9-32.8 28.4-11-1.6-20.9 11.9-16.3 22.1-5.6 3.4-10.9 8.5-11.7 15s5.2 13.9 11.4 12c5.4 6.6 14.1 9 22.3 11 4.7 1.2 9.7 2.4 14.4.9 3.7-1.1 6.4-4 6.9-7.7.1 3.2.7 6.5 1.1 9.6z"
              />
              <path
                fill="#41760A"
                d="M1253.2 78c-1.7 1.9-3.1 4.1-4.8 6-4 4.4-9.9 6.4-15.3 8.6-5.5 2.2-11.2 5.2-13.8 10.6-2.6 5.3-.3 13.4 5.5 14.3-.6 11.8 1.6 23.7 6.3 34.5 2.8 6.3 6.8 12.6 13.1 15.4s15 .6 17.3-5.9c10.4 0 20.9-1.9 30.6-5.5 6.9-2.6 14.7-8.8 12.2-15.8 2.9 3.4 8.6 3.4 12.1.6 3.4-2.9 4.7-7.9 3.8-12.3 12.1 4.6 27.3-3.6 30.1-16.4 14.4 3.4 30.5-9 30.5-24 0-7.9-3.9-15.3-8.7-21.5-13.6-17.3-34.6-24.5-55.8-24.9-13.8-.3-37.2 3.3-26.2 22.6-2.9 2.1-5.3 5.6-6.5 9.1-10.1-1.1-22.4-3.9-30.4 4.6z"
              />
              <path
                fill="#41760A"
                d="M1278.1 121.4c7.3-1.1 14.9-.8 22.1.8 1.1.2 2.3.6 3.1 1.4.8.8 1.2 1.9 1.5 3 1.3 5.3.3 11.1-2.6 15.7-1 1.6-2.3 3.2-2.7 5-.6 2.3.2 4.8.1 7.2-.1 5.2-4.3 9.6-9.2 11.3-4.8 1.7-10.2 1.1-15.2 0-3.9-.9-8-2.4-10.4-5.6-7.9 2.4-16.1 3.9-24.3 4.5-3.3.3-8.2-1.4-7.1-4.6-6.6 3.1-15.3-.2-18.3-6.8-3.2-7-.3-15.4 4.3-21.5 4.6-6 10.9-10.7 17.9-13.4.8-4 1.7-8.2 3.8-11.7 4.6-7.9 13.4-7.3 21.2-5.5 4.1 1 8.3 2.3 11.2 5.4 1.4 1.2 6.8 14.5 4.6 14.8zM1377.3 109.4c4.4 5.6 13.3 7.9 18.8 3.4 5.5 3.8 13 3.1 19.4 1.1s12.5-5.3 19.2-6.1c5.4-.7 11.1.2 16-2.1 6.2-2.8 9.6-9.8 10.9-16.6 1.3-6.8 1.2-13.8 3-20.5 16.2 2.3 35.1.6 45.4-12.3 4.5-5.6 6.8-12.6 9-19.4 2.7-8.4 0-15.3 1.5-24 .6-3.7 2.1-9.2 2.2-13-168.8 2.2-191.5 0-196.1 0-6.9 3.3-13.5 6.5-14.5 13.7-1 6.9 4.3 13 9.2 17.9-8.3 2.7-16.4 7.2-21.2 14.5s-5.3 18 .6 24.5c6.2 6.8 16.6 6.8 25.8 6.3-4 .9-5.3 6.4-3.5 10s5.8 5.6 9.6 7.1c16.4 6.3 34.9 6.7 51.5 1-1.9.6-8.7-3.8-11.1-4-1.2 6.2.5 13.6 4.3 18.5z"
              />
              <path
                fill="#6C9B23"
                d="M1326.7 0c-6.9 3.3-13.5 6.5-14.5 13.7-1 6.9 4.3 13 9.2 17.9-4 1.3-8 3.1-11.6 5.3 2.9 4.1 6.9 7.6 11.4 6.3 5 10.7 15.8 18.4 27.4 19.5 11.6 1.1 23.7-4.3 30.6-13.8 6.3 5.2 13.1 10.7 21.2 11.8 8.1 1.1 17.6-4.2 18-12.5 9 .4 18.1-1.9 25.8-6.6 4.5-2.7 8.9-7.8 7-12.7-2.4-6-10.8-5-16.9-6.8-4.2-1.3-8-4.8-8.4-9.2-.3-4.4 4.1-8.9 8.3-7.6 1.7 3.8 6.6 5.7 10.4 4 3.4-1.5 5.2-5.7 4.4-9.3 0-.4-119.5.1-122.3 0zM1312.3 76.1c-3.5-7.5-7.6-14.9-13.5-20.7-2.7-2.7-5.9-5-9.3-6.6-2.9 3.4-3.4 8.3.6 15.3-2.9 2.1-5.3 5.6-6.5 9.1-10.2-.8-22.5-3.7-30.5 4.9-1.7 1.9-3.1 4.1-4.8 6-4 4.4-9.9 6.4-15.3 8.6-5.5 2.2-11.2 5.2-13.8 10.6-2.6 5.3-.3 13.4 5.5 14.3-.6 11.8 1.6 23.7 6.3 34.5 1.6 3.5 3.5 7.1 6 10 2.7-1.3 5.2-3.4 7-6.2 3.4-5.1 4.4-11.5 4.5-17.7 6.4 1.1 13 2.2 19.3.6 6.3-1.6 12.2-6.7 12.8-13.2.5-6-3.2-13.2.9-17.6 1.4-1.5 3.4-2.2 5.4-2.9l17.7-6c3.2-1.1 6.5-2.3 8.6-4.9 4-5 1.8-12.3-.9-18.1zM1517.8 12.3c-3.5-.9-9-.1-8.4 3.5-5.6-2.6-12.6.1-16.2 5.2s-4.1 11.8-2.8 17.9c-5.9-.1-11.9.6-17.6 2.1-1.7.4-3.5 1-4.8 2.1-2.7 2.3-3.3 6.5-2.2 9.9 1.1 3.4 3.4 6.3 5.7 9-5.2.2-10.1 3.5-12.3 8.3-3.9.3-8 .8-11.1 3.3-1.2 1-2.2 2.2-3.1 3.4-2.7 3.4-5.5 7.5-4.4 11.6.6 2 2 3.7 3.6 5.1 8 7.4 19.3 11.1 30 9.7 1.2 2.2 4.5 1.9 6.6.6s4-3.3 6.5-3.6c2.2-.2 4.2.9 6.3 1.7 8.3 3 18.5-1.8 21.6-10.1 2.5 1.6 5.1 3.3 7.8 4.3V13.7c-2-.6-3.7-1-5.2-1.4z"
              />
              <path
                fill="#815418"
                d="M1433.2 148.7l-.4 28.5c0 .1-2.5-16.8.4-28.5zM1430.5 144.1l-1.4 11.9c.1.1-1.9-6.9 1.4-11.9zM1456.1 208.4s2.9 12.3 3.2 13.2c.4.9.5 17.6.5 17.6l2 18.2-.4-25.9.5-11-5.8-12.1z"
              />
              <path
                fill="#815418"
                d="M1429.5 255.5L1426.1 284.3 1426.9 297.1 1422.4 312 1424.7 295.7 1423.5 281.1z"
              />
              <path
                fill="#815418"
                d="M1464.8 312.4L1465 324.9 1459.8 333.1 1466.2 344 1463.4 333.5 1467 323.5z"
              />
              <path
                fill="#815418"
                d="M1418.6 322.6L1415.4 330.4 1405.5 340.5 1400.9 349 1408.9 341.2 1418.1 330.2z"
              />
              <path
                fill="#815418"
                d="M1449.2 134.8L1453.3 144 1455.6 170.6 1455.6 142.3z"
              />
              <path
                fill="#815418"
                d="M1460.6 168.8l-.8-17.3s3.5 8.3.8 17.3zM1453.1 325.1l-1.3-26.7s4.1 12.9 1.3 26.7zM1466.2 246.5l-.3 24.1s2.5-17.6.3-24.1z"
              />
              <path
                fill="#815418"
                d="M1465.2 293.8L1470.4 314.2 1467.5 296.7z"
              />
              <path
                fill="#815418"
                d="M1421.6 151.1L1409.9 151 1400.1 153.1 1410 152.8z"
              />
              <path
                fill="#815418"
                d="M1364.1 155.7L1350.7 152.6 1339.6 147.2 1350.6 154.7z"
              />
              <path
                fill="#815418"
                d="M1370.5 145.8l-5.9-12.4s6.2 7.8 5.9 12.4z"
              />
              <path fill="#815418" d="M1404.6 163.8L1410.8 160.7 1420 163.7z" />
              <path
                fill="#815418"
                d="M1381.5 154.9L1379.1 154.7 1382 157 1387.7 155.9 1382.5 155.9z"
              />
              <path
                fill="#815418"
                d="M1358.6 158.8L1363.7 158 1368.6 160.6 1362.9 159z"
              />
              <path
                fill="#815418"
                d="M1422.3 324.8L1423.3 335.4 1412.3 347.7 1426.3 335.8z"
              />
              <path
                fill="#815418"
                d="M1430.3 184.7L1431.2 195 1428.5 214.7 1433.9 194.9z"
              />
              <path
                fill="#815418"
                d="M1460.7 196.2L1460.5 182.7 1461.8 171.4 1458.2 182.4z"
              />
              <path
                fill="#815418"
                d="M1429.6 126.8L1432.4 135.5 1433.6 145.3 1433.6 133.6z"
              />
            </g>
            <g>
              <path
                fill="#68C902"
                d="M1515.7 359.4l-8.6-1.5c-2.8-.5-5.7-1-8.2-1.2-2.6-.2-4.9-.1-5.9.4-.2.2-.5.2-.7.4-.1.1-.2.1-.3.3-.1.1-.2.3-.4.4-.1.1-.2.3-.4.5l-.4.6c-.3.5-.5 1-.7 1.5-.4.6-.9 1.2-1.3 1.9.1-.4.1-.7.2-1.1-.1 0-.2.1-.2.2-.1 0-.8-.2-1.2-.4-.4-.2-.7-.4-.8-.4.1-.1.3-.1.5 0-.3-.1-.5-.3-.6-.4-.1-.1-.4-.4-.7-.4 0-.1.8 0 1.9.5-.2-.1-.3-.3-.3-.3-.6-.4-1-.8-1.2-.8.2-.1.8 0 1.2.2-.7-.4-1.1-.8-1.3-1.1-.2-.3-.8-1-1.4-1.1.1-.2 1.3.1 2.7.9-.1-.1-.1-.2-.1-.3 0-.2-.2-.6-.7-.8.1 0 .7.2 1.4.7l-.3-.6c-.5-.8-.7-1-1.4-1.5-.2-.1-.1-.3 0-.2.2.1.4.1.6.2.2-.1.6 0 .9.3-.5-.4-.9-.9-1-1.2-.2-.3-.6-1-1.1-1.2.1-.1.5 0 1.1.3.6.4 1.4 1 2.3 1.9-.3-.4-.3-.6-.4-.8l.1.1c-.9-1.2-1.3-2.2-1.7-2.5.6-.1 1.6.6 2.2 1.5-.8-1.3-1.2-2.6-1.1-3.4.1-.4.1-1 0-1.7s-.3-1.4-.8-1.9c.3-.2.9.2 1.6 1 .7.8 1.4 2.1 2 3.7l.3-.6c.3-.3.7-1.2.4-2.1.3.1.7 1.3 1 3 .2-.4.4-.7.6-1.2.8-1.9.9-2.5.8-4.3 0-.4.3-.6.5-.3.7 1.4.8 3.1.5 5.1-.1 1-.3 1.8-.4 2.4h.3c.1-.3.3-.5.4-.8.6-1.1.6-1.5.6-2.7 0-.3.2-.3.3-.2.3.9.3 2 .1 3.2 0 .1 0 .2-.1.3h1v-.2c.1-.6.2-1 .2-1.2.1.1.2.3.2.6.1-.4.2-.8.3-1 .1-.2.3-.7.2-1 .2-.1.4 1.1.1 2.6.1-.3.2-.4.3-.5v.1c.3-.9.5-1.5.5-1.9.2.2.4 1 .3 1.7.2-1 .6-1.7.9-2.1.3-.4.9-1.4.8-2.2.3 0 .5 1.6.2 3.8.1-.1.2-.2.3-.2.2-.1.7-.5.7-1.2.1.1.1 1-.1 2l.6-.6c.8-1 .9-1.4 1.1-2.6.1-.3.2-.3.3-.1.2.9.1 2.1-.4 3.3-.2.6-.4 1-.6 1.4h.2c.1-.1.3-.2.4-.4.5-.6.6-.9.7-1.6 0-.2.2-.2.2-.1.1.6 0 1.3-.2 2.1 0 .1-.1.1-.1.2 5.3 1.2 9.4 2.7 13.7 4.4-.8.2-1.7.2-2.6.2zm-26-1.6c-.1-.1-.2-.1-.3-.2.1.2.3.3.4.4v-.1s-.1 0-.1-.1z"
              />
            </g>
          </g>
          {resources && (
            <>
              <ResourceLink
                r={resources[0]}
                svgComponent={resource1SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[0], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[1]}
                svgComponent={resource2SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[1], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[2]}
                svgComponent={resource3SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[2], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[3]}
                svgComponent={resource4SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[3], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[4]}
                svgComponent={resource5SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[4], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
              <ResourceLink
                r={resources[5]}
                svgComponent={resource6SVGComponent}
                onElementHover={(e) =>
                  onElementHover(resources[5], e.target as SVGElement)
                }
                onElementLeave={() => onElementHover()}
                onElementClick={onClick}
              />
            </>
          )}
        </g>
      </g>
    </g>
  );
};
export default ArtLink;
